/**
 * Browse ↔ ListingDetail round-trip state.
 *
 * Persists the exact scroll position and the current Browse URL (including
 * filters/query params) in sessionStorage so we can send the user back to
 * the same spot they left off. Persists the specific listing id the user
 * clicked so we can scroll to that card even if the list re-orders slightly
 * between visits.
 *
 * Storage lives in sessionStorage (per-tab, cleared on tab close) — no
 * accidental state leakage across tabs or logins.
 */
const KEY = "h57.browseReturn";

export function saveBrowseReturn(listingId) {
  try {
    const payload = {
      url: `${window.location.pathname}${window.location.search}`,
      scrollY: window.scrollY || window.pageYOffset || 0,
      listingId: listingId || null,
      savedAt: Date.now(),
    };
    sessionStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    /* sessionStorage disabled — silent no-op */
  }
}

export function readBrowseReturn() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    // 30-minute TTL — stale positions after that revert to a fresh browse.
    if (!p || (Date.now() - (p.savedAt || 0)) > 30 * 60 * 1000) return null;
    return p;
  } catch { return null; }
}

export function clearBrowseReturn() {
  try { sessionStorage.removeItem(KEY); } catch { /* noop */ }
}
